// src/components/Login.js (UPDATED with Post-Login Redirect)
import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; 

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { user } = useAuth();

    // If a user is already logged in, redirect them to the correct dashboard
    if (user) {
        if (user.role === 'admin') {
            navigate('/admin-dashboard', { replace: true });
        } else if (user.role === 'hotel') {
            navigate('/hotel-dashboard', { replace: true });
        } else {
             // Fallback for unassigned roles
            navigate('/', { replace: true }); 
        }
        return null; 
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        if (!email || !password) {
            setError("Email and password are required.");
            setLoading(false);
            return;
        }

        try {
            // CRITICAL STEP 1: Firebase Authentication
            await signInWithEmailAndPassword(auth, email, password);
            
            // CRITICAL STEP 2: The 'onAuthStateChanged' in AuthContext fires, 
            // fetching the user's role and setting the 'user' state.
            // The 'if (user)' check at the top of this component will immediately trigger the redirect.
            
        } catch (err) {
            console.error("Firebase Login Error:", err.code, err.message);
            setError("Failed to log in. Check credentials.");
            setLoading(false);
        }
    };

    return (
        <div className="container" style={{paddingTop: '100px'}}>
            <div className="card" style={{maxWidth: '400px', margin: '0 auto'}}>
                <h2>Staff Login</h2>
                
                {error && <p className="error-message info-box">{error}</p>}

                <form onSubmit={handleSubmit}>
                    <label htmlFor="email">Email</label>
                    <input 
                        id="email" 
                        type="email" 
                        placeholder="staff@example.com" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required 
                    />

                    <label htmlFor="password">Password</label>
                    <input 
                        id="password" 
                        type="password" 
                        placeholder="••••••••" 
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required 
                    />
                    
                    <button type="submit" disabled={loading}>
                        {loading ? 'Logging In...' : 'Log In'}
                    </button>
                </form>
            </div>
        </div>
    );
}